/**
 * Detail screens edit the latest canonical note row rather than the scalar Notes column, so a save
 * only persists the note when the edited text is non-empty and differs from that latest note.
 * Returns the content to persist, or null when nothing should be written.
 */
export function resolveNoteToPersist(editedNote: string, latestNoteContent: string | undefined): string | null {
  const trimmed = editedNote.trim();
  if (!trimmed) return null;
  return trimmed === (latestNoteContent ?? '') ? null : trimmed;
}
